import { gql } from '@grandvisionhq/graphql';

var GET_RECENT_ORDERS = gql`
  query getRecentOrders {
    me {
      id
      orders(offset: 0, limit: 2) {
        results {
          orderNumber
          orderDate
          paymentStatus
          lineItems {
            product {
              name {
                value
              }
              mainImage
            }
          }
        }
      }
    }
  }
`;

export { GET_RECENT_ORDERS as default };
//# sourceMappingURL=get-recent-orders.js.map
